import { Theme, Typography, useTheme } from '@mui/material';
import { useContext, useState } from 'react';
import { useParams } from 'react-router-dom';
import BackNavigationButton from '../../../components/common/BackNavigationButton';
import PageContainer from '../../../components/common/PageContainter';
import StyledCard from '../../../components/common/StyledCard';
import StyledCardTitleBar from '../../../components/common/StyledCardTitleBar';
import useInsightsUserProfile from '../../../hooks/useInsightsUserProfile';
import useInsightsUserSpendingsCompareDetailed from '../../../hooks/useInsightsUserSpendingsCompare';
import useInsightsUserPurchases from '../../../hooks/useInsigntsUserPurchases';
import useSubscriber from '../../../hooks/useSubscriber';
import { SettingsContext } from '../../../store/SettingsContext';
import { parseNumberOrNull } from '../../../utils/common';
import FanSpendingGauge from './FanSpendingGauge';
import UserProfile from './UserProfile';

const InsightsUser = () => {
    const settingsContext = useContext(SettingsContext);
    const theme: Theme = useTheme();
    const params = useParams<{ userId: string; onlyFansUserId: string }>();
    const onlyFansUserId = parseNumberOrNull(params.onlyFansUserId);

    const { data: subscriber, isLoading: isSubscriberLoading } = useSubscriber();

    const {
        data: insightsUserProfile,
        isLoading: isInsightsUserProfileLoading,
        refetch: insightsUserProfileRefetch,
        insightsSaveUserRealName,
        isInsightsUserProfileSaving,
    } = useInsightsUserProfile(onlyFansUserId);

    const { data: insightsUserSpendingsCompareDetailed, isLoading: isInsightsUserSpendingsCompareDetailedLoading } =
        useInsightsUserSpendingsCompareDetailed(onlyFansUserId);

    const [fanPurchasesCursorDate, setFanPurchasesCursorDate] = useState<Date | undefined>(undefined);

    const { data: insightsUserPurchases, isLoading: isInsightsUserPurchasesLoading } = useInsightsUserPurchases(
        onlyFansUserId,
        fanPurchasesCursorDate,
    );

    console.log('insightsUserPurchases', insightsUserPurchases, isInsightsUserPurchasesLoading);

    if ((!subscriber || !subscriber._id) && !isSubscriberLoading) {
        return (
            <PageContainer>
                <Typography variant="h5" sx={{ mb: 2 }}>
                    <BackNavigationButton url={`/subscribers/${params.userId}/${settingsContext.services.sextforce.homeUrl}`} /> Insights
                </Typography>
            </PageContainer>
        );
    }

    return (
        <PageContainer>
            <Typography variant="h5" sx={{ mb: 2 }}>
                <BackNavigationButton url={`/subscribers/${subscriber?._id}/${settingsContext.services.sextforce.homeUrl}`} /> Insights for{' '}
                {subscriber?.username}
            </Typography>

            <StyledCard noCard noBottomMargin>
                <StyledCardTitleBar title="Profile" isLoading={isInsightsUserProfileLoading} />
            </StyledCard>

            <StyledCard>
                {isInsightsUserProfileLoading ? (
                    <Typography variant="body1" sx={{ p: 2 }}>
                        Loading...
                    </Typography>
                ) : (
                    <UserProfile
                        sextforceUser={insightsUserProfile}
                        loading={isInsightsUserProfileLoading}
                        insightsUserProfileRefetch={insightsUserProfileRefetch}
                        insightsSaveUserRealName={insightsSaveUserRealName}
                        isInsightsUserProfileSaving={isInsightsUserProfileSaving}
                        comparisonResult={insightsUserSpendingsCompareDetailed}
                    />
                )}
            </StyledCard>

            <StyledCard noCard noBottomMargin>
                <StyledCardTitleBar title="Spending Analysis" isLoading={isInsightsUserSpendingsCompareDetailedLoading} />
            </StyledCard>

            <StyledCard>
                <FanSpendingGauge
                    comparisonResult={insightsUserSpendingsCompareDetailed}
                    loading={isInsightsUserSpendingsCompareDetailedLoading}
                    userProfile={insightsUserProfile?.user}
                    variant="detailed"
                />
            </StyledCard>
        </PageContainer>
    );
};

export default InsightsUser;
